import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoashtavinayakdarshan() {



    const cardData =
    {
        keyword: 'Pune to Ashtavinayak Darshan Urbania Bus',
        heading: 'Urbania on rent in pune: Pune to Ashtavinayak Darshan Urbania Bus',
        headingDescription: 'Urbania On Rent in Pune offers premium and reliable Pune to Ashtavinayak Darshan Urbania Bus services for devotees, families, corporate groups, and tourists planning a comfortable spiritual journey. Our well-maintained Force Urbania bus fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for visiting all eight Ashtavinayak temples in a safe and relaxed manner. With professional chauffeurs experienced in pilgrimage routes, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a peaceful and stress-free darshan experience. Backed by 24/7 booking support, transparent pricing, and punctual service, Urbania On Rent in Pune stands out as the trusted choice for Pune to Ashtavinayak Darshan Urbania bus hire.',

        top: 'Top Places to Visit in Ashtavinayak with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Moreshwar Ganpati – Morgaon",
    "description": "Moreshwar Ganpati Temple at Morgaon is considered the first and most important temple of the Ashtavinayak pilgrimage. Lord Ganesha is worshipped here as Mayureshwar, seated on a peacock. Surrounded by a stone wall with four minarets, the temple has a unique mosque-like structure reflecting historical harmony. Devotees believe that beginning and ending the Ashtavinayak yatra here brings fulfillment and divine blessings. The serene village setting adds to its spiritual charm."
  },
  {
    "title": "Siddhivinayak – Siddhatek",
    "description": "Siddhivinayak Temple at Siddhatek is the only Ashtavinayak shrine where Lord Ganesha is depicted with his trunk turned to the right, symbolizing power and wish fulfillment. Located on the banks of the Bhima River, the temple is associated with Lord Vishnu, who is believed to have attained victory after worshipping Ganpati here. The hilltop temple requires a short climb, offering a peaceful and spiritually uplifting experience."
  },
  {
    "title": "Ballaleshwar – Pali",
    "description": "Ballaleshwar Temple at Pali is dedicated to Ballal, a young devotee whose unwavering faith pleased Lord Ganesha. This temple uniquely remains open 24 hours for devotees. Built with black stone and supported by wooden pillars, it reflects traditional Peshwa-era architecture. The temple’s calm atmosphere and deep devotional significance make it a cherished stop in the Ashtavinayak circuit."
  },
  {
    "title": "Varadvinayak – Mahad",
    "description": "Varadvinayak Temple in Mahad is believed to grant wishes to true devotees. The temple houses a self-manifested idol of Lord Ganesha and features an ancient oil lamp that has been continuously burning since 1892. The open sanctum allows devotees to directly approach the deity, creating a personal and intimate spiritual connection. The peaceful rural surroundings enhance the divine experience."
  },
  {
    "title": "Chintamani – Theur",
    "description": "Chintamani Ganpati Temple at Theur is associated with relief from worries and mental stress. Located near the confluence of the Mula and Mutha rivers, it has strong historical links with the Peshwas, especially Madhavrao I. The wooden mandap and spacious courtyard reflect traditional Maratha temple architecture. Devotees believe worship here brings peace of mind and clarity in life decisions."
  },
  {
    "title": "Girijatmaj – Lenyadri",
    "description": "Girijatmaj Temple at Lenyadri is the only Ashtavinayak temple situated inside a Buddhist cave complex. Carved into a single rock mountain, it requires climbing around 300 steps to reach the sanctum. Lord Ganesha is believed to have been born here to Goddess Parvati. The cave temple offers a rare blend of natural beauty, ancient architecture, and deep spiritual significance."
  },
  {
    "title": "Vighnahar – Ozar",
    "description": "Vighnahar Ganpati Temple at Ozar is worshipped as the remover of obstacles and challenges. The temple features gold-plated domes and a beautifully maintained courtyard. Situated near the Kukadi River, it is surrounded by greenery and tranquility. Devotees visit this shrine seeking success, protection, and smooth progress in personal and professional life."
  },
  {
    "title": "Mahaganapati – Ranjangaon",
    "description": "Mahaganapati Temple at Ranjangaon is the last temple of the Ashtavinayak pilgrimage. Lord Ganesha here is believed to possess immense power, symbolizing strength and wisdom. The temple has wide entrances, allowing sunlight to illuminate the idol during specific times of the year. It is said that Lord Shiva worshipped Ganpati here before defeating Tripurasura, making it a highly revered spiritual destination."
  }
],




 "services": [
    {
      "name": "Pune to Ashtavinayak Darshan Urbania Bus",
      "description": "Pune to Ashtavinayak Darshan Urbania Bus offers comfortable and reliable bus services for devotees visiting all eight Ashtavinayak temples, ensuring a peaceful and well-organized pilgrimage journey."
    },
    {
      "name": "Ashtavinayak Darshan Urbania Hire Pune",
      "description": "Ashtavinayak Darshan Urbania Hire Pune provides AC and non-AC Urbania buses with experienced drivers, ideal for families and groups planning a spiritual tour from Pune."
    },
    {
      "name": "Urbania Bus for Ashtavinayak Tour",
      "description": "Urbania Bus for Ashtavinayak Tour ensures a smooth and comfortable pilgrimage experience with spacious seating, ample luggage space, and knowledgeable chauffeurs."
    },
    {
      "name": "Pune Ashtavinayak Darshan Urbania Rental",
      "description": "Pune Ashtavinayak Darshan Urbania Rental offers flexible rental options for one-day or multi-day Ashtavinayak temple tours, focusing on safety and comfort."
    },
    {
      "name": "Urbania AC Bus Ashtavinayak Tour",
      "description": "Urbania AC Bus Ashtavinayak Tour provides fully air-conditioned buses for a relaxing and climate-controlled journey to all Ashtavinayak temples."
    },
    {
      "name": "Family Ashtavinayak Darshan Urbania Pune",
      "description": "Family Ashtavinayak Darshan Urbania Pune is designed for families, offering comfortable seating, safe travel, and a peaceful pilgrimage experience."
    },
    {
      "name": "Corporate Ashtavinayak Darshan Urbania Pune",
      "description": "Corporate Ashtavinayak Darshan Urbania Pune offers organized and punctual bus services for corporate groups planning spiritual or team pilgrimage tours."
    },
    {
      "name": "Luxury Urbania Ashtavinayak Tour",
      "description": "Luxury Urbania Ashtavinayak Tour delivers premium buses with plush interiors, superior comfort, and professional chauffeurs for a refined pilgrimage experience."
    },
    {
      "name": "Affordable Ashtavinayak Darshan Urbania Pune",
      "description": "Affordable Ashtavinayak Darshan Urbania Pune provides budget-friendly Urbania bus rentals without compromising on safety, comfort, or reliability."
    },
    {
      "name": "Chauffeur Driven Urbania Ashtavinayak Tour",
      "description": "Chauffeur Driven Urbania Ashtavinayak Tour ensures a stress-free pilgrimage with trained, verified drivers familiar with Ashtavinayak routes."
    },
    {
      "name": "Best Ashtavinayak Darshan Urbania Package Pune",
      "description": "Best Ashtavinayak Darshan Urbania Package Pune offers complete tour packages covering all temples with comfortable buses and professional service."
    },
    {
      "name": "Group Travel Ashtavinayak Urbania",
      "description": "Group Travel Ashtavinayak Urbania provides spacious and reliable bus services for large groups and devotees traveling together from Pune."
    },
    {
      "name": "Pilgrimage Urbania Hire Pune",
      "description": "Pilgrimage Urbania Hire Pune specializes in religious tours, offering clean buses, courteous drivers, and well-planned travel schedules."
    },
    {
      "name": "Pune Ashtavinayak Darshan Bus Booking",
      "description": "Pune Ashtavinayak Darshan Bus Booking enables easy and quick booking of Urbania buses for a smooth and well-coordinated pilgrimage tour."
    },
    {
      "name": "Trusted Ashtavinayak Urbania Service",
      "description": "Trusted Ashtavinayak Urbania Service delivers dependable and secure transportation with a focus on customer satisfaction and spiritual comfort."
    }
  ],
  "tableData": [
    ["Pune to Ashtavinayak Darshan Urbania Bus", "Ashtavinayak Darshan Urbania Hire Pune"],
    ["Urbania Bus for Ashtavinayak Tour", "Pune Ashtavinayak Darshan Urbania Rental"],
    ["Urbania AC Bus Ashtavinayak Tour", "Family Ashtavinayak Darshan Urbania Pune"],
    ["Corporate Ashtavinayak Darshan Urbania Pune", "Luxury Urbania Ashtavinayak Tour"],
    ["Affordable Ashtavinayak Darshan Urbania Pune", "Chauffeur Driven Urbania Ashtavinayak Tour"],
    ["Best Ashtavinayak Darshan Urbania Package Pune", "Group Travel Ashtavinayak Urbania"],
    ["Pilgrimage Urbania Hire Pune", "Pune Ashtavinayak Darshan Bus Booking"],
    ["Trusted Ashtavinayak Urbania Service", ""]
  ],



 whychoose : [
    {
        "WhyChooseheading": "Pune to Ashtavinayak Darshan Urbania Bus for Spiritual Comfort",
        "WhyChoosedescription": "Pune to Ashtavinayak Darshan Urbania Bus is ideal for devotees, families, and groups planning a peaceful and well-organized pilgrimage covering all eight Ashtavinayak temples."
    },
    {
        "WhyChooseheading": "Spacious and Modern Urbania Buses",
        "WhyChoosedescription": "Our Urbania buses for Pune to Ashtavinayak Darshan are equipped with air-conditioning, comfortable reclining seats, ample legroom, and sufficient luggage space for a relaxed journey."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Ashtavinayak Routes",
        "WhyChoosedescription": "All drivers are trained and experienced with the complete Ashtavinayak temple circuit, ensuring safe travel, proper timing, and smooth temple visits."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Pune to Ashtavinayak Darshan Urbania Bus offers competitive pricing with no hidden charges, making your pilgrimage economical and stress-free."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "We provide round-the-clock booking assistance and dedicated customer support for planning, scheduling, and last-minute darshan requirements."
    },
    {
        "WhyChooseheading": "Flexible Darshan Packages",
        "WhyChoosedescription": "Available for one-day, two-day, and customized Ashtavinayak Darshan packages based on group size, temple sequence, and travel preferences."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania buses are regularly cleaned, sanitized, and well-maintained to ensure passenger comfort and hygiene throughout the pilgrimage."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Pilgrimage Service",
        "WhyChoosedescription": "Our Pune to Ashtavinayak Darshan Urbania Bus service ensures on-time pickups, organized temple visits, and dependable transportation."
    }
]
}
const faqData = [
    {
        question: 'Can Pune to Ashtavinayak Darshan Urbania Bus be booked for group travel?',
        answer: 'Yes, it is perfect for group pilgrimages, family darshan trips, senior citizens, and devotional tours.'
    },
    {
        question: 'How can I book Pune to Ashtavinayak Darshan Urbania Bus?',
        answer: 'Bookings can be made via phone, WhatsApp, or online for quick and convenient reservations.'
    },
    {
        question: 'Why choose Pune to Ashtavinayak Darshan Urbania Bus?',
        answer: 'This service offers comfortable seating, experienced drivers, clean vehicles, flexible darshan packages, and transparent pricing.'
    },
    {
        question: 'Are the drivers familiar with all Ashtavinayak temples?',
        answer: 'Yes, all drivers are trained and familiar with the complete Ashtavinayak route and temple locations.'
    },
    {
        question: 'Can pickup and drop locations be customized?',
        answer: 'Absolutely. Flexible pickup and drop-off locations are available across Pune and nearby areas.'
    },
    {
        question: 'Is Pune to Ashtavinayak Darshan Urbania Bus available 24/7?',
        answer: 'Yes, booking services and customer support are available 24/7.'
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are thoroughly cleaned, sanitized, and maintained for passenger safety and comfort.'
    },
    {
        question: 'What payment options are accepted?',
        answer: 'Payments can be made via UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing.'
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the Ashtavinayak Darshan journey.'
    },
    {
        question: 'Is this service suitable for families and senior citizens?',
        answer: 'Yes, Pune to Ashtavinayak Darshan Urbania Bus is ideal for families, senior citizens, and devotional groups.'
    }
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Vinayak Kulkarni',
        feedback: 'The Pune to Ashtavinayak Darshan Urbania Bus made our pilgrimage very comfortable. Smooth travel and well-managed temple visits.',
        rating: 5
    },
    {
        id: 2,
        name: 'Mrs. Sunita Patwardhan',
        feedback: 'Excellent service for Ashtavinayak Darshan. Clean bus, polite driver, and perfect scheduling. Highly recommended.',
        rating: 5
    },
    {
        id: 3,
        name: 'Mr. Nilesh More',
        feedback: 'Our family Ashtavinayak Darshan from Pune was peaceful and enjoyable thanks to the reliable Urbania bus service.',
        rating: 5
    }
];





































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ashtavinayak Darshan Urbania Bus",
  "image": "https://urbaniaonrentpune.in/assets/images/pune-ashtavinayak-urbania.jpg",
  "description": "Pune to Ashtavinayak Darshan Urbania Bus offers AC Urbania buses for one-way or round-trip travel, corporate trips, family tours, pilgrimage journeys, and group travel. Chauffeur-driven Urbania buses ensure safe, comfortable, and convenient transportation from Pune to Ashtavinayak temples.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/pune-to-ashtavinayak-urbania-bus"
  }
};








    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Pune to Ashtavinayak Darshan Urbania Bus | AC Urbania Bus One Way & Round Trip 
  </title>

  <meta
    name="description"
    content="Book Pune to Ashtavinayak Darshan Urbania Bus for one-way or round-trip travel, corporate trips, family tours, pilgrimage journeys, and group travel. AC Urbania buses with chauffeur-driven service provide safe, comfortable, and convenient transportation from Pune to Ashtavinayak temples."
  />

  <meta
    name="keywords"
    content="Pune to Ashtavinayak Darshan Urbania Bus, Ashtavinayak Darshan Urbania Hire Pune, Urbania Bus for Ashtavinayak Tour, Pune Ashtavinayak Darshan Urbania Rental, Urbania AC Bus Ashtavinayak Tour, Family Ashtavinayak Darshan Urbania Pune, Corporate Ashtavinayak Darshan Urbania Pune, Luxury Urbania Ashtavinayak Tour, Affordable Ashtavinayak Darshan Urbania Pune, Chauffeur Driven Urbania Ashtavinayak Tour, Best Ashtavinayak Darshan Urbania Package Pune, Group Travel Ashtavinayak Urbania, Pilgrimage Urbania Hire Pune, Pune Ashtavinayak Darshan Bus Booking, Trusted Ashtavinayak Urbania Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/83.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoashtavinayakdarshan;